import { motion } from "framer-motion";
import { Calendar } from "lucide-react";
import { useModal } from "./ModalContext";

export function SecureDateCTA({ heading, subtext, variant = "default", venueName }) {
  const { openModal } = useModal();

  if (variant === "inline") {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="flex flex-col sm:flex-row items-center justify-between gap-4 py-8 px-6 md:px-10 border border-[#C2A878]/20 bg-[#C2A878]/[0.04]"
        data-testid="secure-date-cta-inline"
      >
        <div>
          <p className="font-serif text-lg sm:text-xl text-[#F5F5F0] tracking-tight">
            {heading || "Like what you see?"}
          </p>
          <p className="text-sm text-[#A19D94] font-sans mt-1">
            {subtext || "Pop your date in and we'll check availability."}
          </p>
        </div>
        <button
          onClick={openModal}
          data-testid="secure-date-btn-inline"
          className="shrink-0 px-6 py-3 bg-[#C2A878] text-[#0A0908] text-sm font-sans font-medium tracking-wide hover:bg-[#d4bc92] transition-colors"
        >
          Secure Your Date
        </button>
      </motion.div>
    );
  }

  if (variant === "minimal") {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-center py-4"
        data-testid="secure-date-cta-minimal"
      >
        <button
          onClick={openModal}
          data-testid="secure-date-btn-minimal"
          className="inline-flex items-center gap-2 text-[#C2A878] hover:text-[#d4bc92] transition-colors text-sm font-sans group"
        >
          <Calendar size={14} />
          <span className="group-hover:underline underline-offset-4">Secure your date</span>
        </button>
      </motion.div>
    );
  }

  // default: full width banner CTA
  return (
    <section data-testid="secure-date-cta-banner" className="bg-[#0A0908] py-16 md:py-20">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto px-6 md:px-12 text-center"
      >
        <p className="text-xs tracking-[0.2em] uppercase text-[#C2A878] font-sans mb-4">
          {venueName ? `Book ${venueName}` : "Don't Miss Out"}
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight font-light text-[#F5F5F0] leading-tight">
          {heading || "Ready to secure your date?"}
        </h2>
        <p className="mt-4 text-base text-[#A19D94] font-sans leading-relaxed max-w-xl mx-auto">
          {subtext || "We only take a limited number of weddings each month. Pop your details in and we'll get back to you within 24 hours."}
        </p>
        <button
          onClick={openModal}
          data-testid="secure-date-btn-banner"
          className="mt-8 px-10 py-4 bg-[#C2A878] text-[#0A0908] text-sm font-sans font-medium tracking-wider uppercase hover:bg-[#d4bc92] transition-colors"
        >
          Secure Your Date
        </button>
        <p className="mt-3 text-xs text-[#A19D94]/50 font-sans">
          No obligation. We'll get back to you within 24 hours.
        </p>
      </motion.div>
    </section>
  );
}
